import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { mainInformation } from '../../../../routes'
import styles from './styles.module.scss'
import SwiperCore, { Pagination } from 'swiper'
import parse from "html-react-parser";
SwiperCore.use([Pagination]);
const WhyGenerium = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.title}>Наши преимущества</p>
        <div className={styles.list}>
          <div className={styles.item}>
            <p className={styles.number}>8000</p>
            <p className={styles.text_lg}>
              м&sup2;&nbsp;исследовательских <br />лабораторий
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>73</p>
            <p className={styles.text_lg}>
              сотрудников имеют учёную <br />степень
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>4</p>
            <p className={styles.text_lg}>
              сотрудников защитили <br />диссертации, работая <br />в Generium
            </p>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>Почему Generium?</p>
          <p className={styles.text}>
            В компании вы сможете сосредоточиться на профессиональных достижениях.&nbsp;
            <br />А мы позаботимся о мелочах, которые от них отвлекают.
          </p>
        </div>

        <div className={styles.slider}>
          <Swiper
            pagination={true}
            spaceBetween={16}
            slidesPerView={3}
            initialSlide={0}
            loop={true}
            speed={5000}
            // autoplay={{
            //   delay: 3000
            // }}
            // modules={[Autoplay]}
            breakpoints={{
              1440: {
                slidesPerView: 3
              },
              1365: {
                slidesPerView: 3
              },
              1025: {
                slidesPerView: 2.3,
                spaceBetween: 24
              },
              769: {
                slidesPerView: 2.5,
                spaceBetween: 16
              },
              686: {
                slidesPerView: 3,
                spaceBetween: 16
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 16
              },
              380: {
                slidesPerView: 1.5,
                spaceBetween: 16
              },
              320: {
                slidesPerView: 1.3,
                spaceBetween: 16
              }
            }}
          >
            {mainInformation !== undefined ?
              mainInformation
                .filter((elem, i) => i < 20)
                .map((item, index) => (
                  <>
                    <SwiperSlide key={item.id}>
                      <div className={styles.slider_item}>
                        <div className={styles.slider_item_inner}>
                          <div className={styles.slider_item_front}>
                            <p className={styles.slider_item_p1}>{item.title}</p>
                            <img src={item.img} alt='icons' draggable='false'/>
                          </div>
                          <div className={styles.slider_item_back}>
                            <p className={styles.slider_item_p1}>{parse(item.text)}</p>
                          </div>
                        </div>
                        <div className={styles.slider_item_mobile}>
                          <p className={styles.slider_item_p1}>{item.title}</p>
                          <img src={item.img} alt='icons' draggable='false'/>
                          <p className={styles.slider_item_p2}>{parse(item.text)}</p>
                        </div>
                      </div>
                    </SwiperSlide></>
                )) : ""}
           </Swiper>
        </div>
      </div>
    </div>
  )
}

export default WhyGenerium
